// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, timesheetFieldService } from "../../../app/rpc"
import {
  ListFavouriteTimesheetFieldOptionsRequestSchema,
  ListFavouriteTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type ListFavouriteTimesheetFieldOptionsRpc = (request: Init<typeof ListFavouriteTimesheetFieldOptionsRequestSchema>) => Observable<ListFavouriteTimesheetFieldOptionsResponse>

export const listFavouriteTimesheetFieldOptions = (listFavouriteTimesheetFieldOptionsRpc: ListFavouriteTimesheetFieldOptionsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listFavouriteTimesheetFieldOptions.match),
      mergeMap((action) => listFavouriteTimesheetFieldOptionsRpc(action.payload)
        .pipe(
          map(response => ({
            siteId: action.payload.siteId ?? "",
            options: response.timesheetFieldOptions,
          })),
          map(Slice.setFavouriteTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_list_favourite_timesheet_field_options_failed",
              message: "Failed to load favourite timesheet field options. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )),
    )

const listFavouriteTimesheetFieldOptionsRpc = (request: Init<typeof ListFavouriteTimesheetFieldOptionsRequestSchema>): Observable<ListFavouriteTimesheetFieldOptionsResponse> =>
  executor(() => timesheetFieldService.listFavouriteTimesheetFieldOptions(create(ListFavouriteTimesheetFieldOptionsRequestSchema, request)))

export default listFavouriteTimesheetFieldOptions(listFavouriteTimesheetFieldOptionsRpc)
